import { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import {
  Form,
  Button,
  TextFieldControlled as Input,
  SelectFieldNativeControlled as Select,
} from '@leafwell/components';
import { useWordPressContext } from 'contexts/wordpress-provider';
import { useBrazeContext } from 'contexts/braze-context';
import { useEventsTracker } from 'contexts/eventsTracker';

export default function ContactUsForm() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const posthog = usePostHog();
  const { trackEvent } = useEventsTracker();
  const { saveUser: saveBrazeUser } = useBrazeContext();
  const { translations } = useWordPressContext();

  const contactOptions = [
    {
      label: translations['My account'],
      value: 'my_account',
    },
    {
      label: translations['Getting certified'],
      value: 'certification',
    },
    {
      label: translations['A renewal'],
      value: 'renewal',
    },
    {
      label: translations['Medical marijuana'],
      value: 'medical_marijuana',
    },
    {
      label: translations['Something else'],
      value: 'other',
    },
  ];

  async function handleSubmit({ name, email, phone, contact_reason, message }) {
    // https://posthog.com/docs/product-analytics/identify#alias-assigning-multiple-distinct-ids-to-the-same-user
    posthog.alias(email);

    saveBrazeUser({
      name,
      email,
    });

    trackEvent({
      event: 'form_submit',
      form_name: `formType_${window?.location?.pathname}`,
      form_destination: window?.location?.pathname,
      form_submit_text: translations['Submit'],
      formType: 'contact_us',
      name,
      email,
      phone,
      contact_reason,
      message,
    });

    setFormSubmitted(true);
  }

  return (
    <Form
      className="gap-y-4"
      mode="onSubmit"
      defaultValues={{
        name: '',
        email: '',
        phone: '',
        contact_reason: '',
        state: '',
        message: '',
      }}
      onSubmit={handleSubmit}
    >
      {formSubmitted ? (
        <p className="text-center">
          Thank you for your enquiry.
          <br />
          One of our team will be in touch with you as soon as possible.
        </p>
      ) : (
        <>
          <Input
            className="rounded-lg"
            type="text"
            name="Name"
            placeholder={`${translations['Name']} *`}
            validations={['required']}
          />
          <Input
            className="rounded-lg"
            type="email"
            name="email"
            placeholder={`${translations['Email']} *`}
            validations={['required', 'email']}
          />
          <Input
            className="rounded-lg"
            type="tel"
            name="phone"
            placeholder="Phone (optional)"
          />
          <Select
            aria-label="Reason for Contact"
            name="contact_reason"
            placeholder={'Reason for Contact (optional)'}
            options={contactOptions}
            className="rounded-lg"
          />
          <Input
            className="rounded-lg"
            type="textarea"
            name="message"
            placeholder="Message"
          />
          <Button
            type="submit"
            label={translations['Submit']}
            name="submit"
            variant="secondary"
            className="w-full rounded-lg"
          />
        </>
      )}
    </Form>
  );
}
